import { APIStatus } from "@application/common/enums/api-status";
import { createSlice } from "@reduxjs/toolkit";
import { createRolePermissionAsync, updateRolePermissionAsync, getRolePermissionsByIdAsync, getAllPermissionsAsync, getRolePermissionsByRoleNameAsync } from "./rolepermissionThunk";
import LocalStorageService from "@infrastructure/local-storage-service";
const initialState = {
    status: APIStatus.IDLE,
};
export const rolePermissionSlice = createSlice({
    name: 'rolePermission',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPermissionsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPermissionsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.permissions = action.payload;
        })
            .addCase(getAllPermissionsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getRolePermissionsByRoleNameAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRolePermissionsByRoleNameAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.rolePermissions = action.payload;
        })
            .addCase(getRolePermissionsByRoleNameAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createRolePermissionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createRolePermissionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdRolePermissions = action.payload;
        })
            .addCase(createRolePermissionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateRolePermissionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateRolePermissionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedRolePermissions = action.payload;
        })
            .addCase(updateRolePermissionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getRolePermissionsByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRolePermissionsByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.rolePermissions = action.payload;
            if (LocalStorageService.getRolePermission() === null) {
                LocalStorageService.setRolePermission(action.payload);
            }
        })
            .addCase(getRolePermissionsByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default rolePermissionSlice.reducer;
